module.exports = ".thumbnail {\n    cursor: pointer;\n}\n\n.modal {\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    background-color: rgba(32, 32, 32, .6);\n}\n\n.lightbox, .title {\n    text-align: center;\n}\n\n.close {\n    background: #5c2018;\n    font-size: 48px;\n    text-decoration: none;\n    position: absolute;\n    top: 0;\n    right: 0;\n    cursor: pointer;\n    padding: 0 10px 0;\n    border-radius: 15px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/lightbox-thumbnail/lightbox-thumbnail.component.css
// module id = ./src/app/lightbox-thumbnail/lightbox-thumbnail.component.css
// module chunks = main